const fastSellProductConvertToMarketProductFormInitialValues = (fastSellProduct) => ({
  product_category: fastSellProduct?.product_category || {
    id    : '',
    label : ''
  },
  price_offer: fastSellProduct?.price_offers[0]?.price || 0
})

export default fastSellProductConvertToMarketProductFormInitialValues
